var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolSearchIcVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 10C38.9696 10 46.8884 16.081 53.7781 27.8588L54.2929 28.7528L55 30L53.7781 32.1412C46.8884 43.919 38.9696 50 30 50C21.0304 50 13.1116 43.919 6.22186 32.1412L5.70706 31.2472L5 30L5.70706 28.7528C12.7163 16.3889 20.8061 10 30 10ZM30 15C23.2423 15 16.8207 19.7888 10.7633 30C16.8207 40.2112 23.2423 45 30 45C36.5742 45 42.8222 40.4752 48.7176 30.8618L49.2369 30.0003L48.7168 29.1383C42.8122 19.5192 36.5647 15 30 15ZM30 22.5C34.1421 22.5 37.5 25.8579 37.5 30C37.5 34.1421 34.1421 37.5 30 37.5C25.8579 37.5 22.5 34.1421 22.5 30C22.5 25.8579 25.8579 22.5 30 22.5Z",
    fill: "#0057D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolSearchIcVisibility);
export default __webpack_public_path__ + "static/media/sol-search-ic-visibility.63140e20e6b80890ab81dcd54bddbbf2.svg";
export { ForwardRef as ReactComponent };